'use strict';

var angular = require('angular');
var _ = require('lodash');
var AnalysisChartDirective = function AnalysisChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/analysis-chart.html'),
    controller: 'AnalysisChartController',
    scope: {
      displayedCalendar: '=',
      seasonalityType: '@',
      isDemandSeasonality: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, scope.chartFormatters, scope.seasonalityType);
      scope.renderChartDataPresent = function (data) {
        chart.withMetric(scope.displayedCalendar.selectedMetric).render(data);
      };
      scope.setInitialSelection = function (range) {
        chart.setInitialSelection(range);
      };
      chart.on('rangechange', function (range) {
        var selectedBars = _.flatten(chart.getSelectedBars());
        scope.updateContextMenu(selectedBars);
      });
      scope.showCalendarModal = function () {
        angular.element('#seasonality-review-calendar-modal').modal('show');
      };
      scope.$on('context-menu:analysis-chart-assign', function (e, context) {
        var selection = chart.getSelection();
        _.each(selection, function (item) {
          scope.updateOverrideData(item, context);
        });
      });
    }
  };
};
AnalysisChartDirective.$inject = ['AnalysisChart'];
module.exports = AnalysisChartDirective;